import { Component, Input, OnInit } from '@angular/core';
import { NativeMarket } from '@capacitor-community/native-market';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { FlagsService } from 'src/app/services/config/flags.service';
import { environment } from 'src/environments/environment.prod';

@Component({
    selector: 'app-mm-update-app',
    templateUrl: './mm-update-app.component.html',
    styleUrls: ['./mm-update-app.component.scss'],
    standalone: false
})
export class MmUpdateAppComponent implements OnInit {

    forceUpdate: boolean = false;
    title: string = 'Nova versão disponível!';
    subtitle: string = 'Estamos constantemente aprimorando nosso aplicativo. Você precisa atualizar para continuar utilizando.';
    changeLog: string[] = [];
    urlImage: string = '';

    @Input() fromOta: boolean = false;

    constructor(private modalCtrl: ModalController,
        private flagsService: FlagsService
    ) { }

    async ngOnInit() {
        let infoUpdate = this.flagsService.update_app_by_version;
        if (infoUpdate.force_update) {
            this.forceUpdate = true;
        }
        this.title = infoUpdate.title;
        this.subtitle = infoUpdate.subtitle;
        this.changeLog = infoUpdate.change_log;
        this.urlImage = infoUpdate.url_img;
    }

    touchClose() {
        this.modalCtrl.dismiss();
        sessionStorage.setItem('update-later', 'true');
    }

    async touchUpdate() {
        if (this.fromOta) {
            // TODO: Implementar lógica para atualização via OTA
            this.modalCtrl.dismiss({ update: true });
            return;
        }
        let appId = Capacitor.getPlatform() === "android" ? environment.googleStoreId : environment.appleStoreId;
        NativeMarket.openStoreListing({
            appId: appId,
        });

        this.modalCtrl.dismiss();
    }
}
